/**
 * Kept in its own module so tests can replace the loader and so the MapLibre
 * chunk is not part of the initial discovery bundle.
 */
import workerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?url'

export type MaplibreModule = typeof import('maplibre-gl')

export async function loadMaplibre(): Promise<MaplibreModule> {
  const maplibregl = await import('maplibre-gl')
  // Vite hashes the MapLibre worker; without an explicit URL the package
  // requests /assets/maplibre-gl-worker.mjs, which is not emitted by the
  // production build. Point it at the emitted hashed asset instead.
  maplibregl.setWorkerUrl(workerUrl)
  return maplibregl
}

/**
 * OpenFreeMap bright + the CSP/attribution facts for this style:
 * - style/tiles/glyphs/sprites: https://tiles.openfreemap.org
 * - MapLibre runs its worker from a hashed same-origin module URL.
 * Both are already allowed by `infra/nginx/app.conf` (`connect-src`,
 * `img-src`, `worker-src 'self' blob:`) and by the Tauri CSP. No CSP change is
 * needed for this slice.
 */
export const OPENFREEMAP_BRIGHT_STYLE =
  'https://tiles.openfreemap.org/styles/bright'

export const MAP_ATTRIBUTION =
  'OpenFreeMap © OpenMapTiles © OpenStreetMap contributors'
